export function isComponentSchema(schema) {
  if (typeof schema === 'object') {
    return schema.componentName === 'Component';
  }
  return false;
}